import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-119" data-mp="4m8lmajdinjv">
      {/* Mobile: promise → mockup → details. Desktop: copy left, mockup right. */}
      <div className="mx-auto grid max-w-6xl gap-x-12 px-6 pb-12 pt-8 sm:pt-12 lg:grid-cols-[1fr_1.05fr] lg:items-center lg:pb-16 lg:pt-14" data-id="element-120" data-mp="12860lxyjoar2">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-121" data-mp="x8jnrpmmowis">
          <Pill tone="accent" data-id="element-122" data-mp="sd4b310cx6ny">For handball coaches</Pill>

          <h1 className="mt-5 font-display text-[2.6rem] font-extrabold uppercase leading-[0.92] text-fg sm:text-6xl lg:text-[4.4rem]" data-id="element-123" data-mp="nb6njukxbpp7">
            Plan your next handball session in{' '}
            <span className="text-accent" data-id="element-124" data-mp="3825w6klg5xiq">5 minutes</span>
          </h1>

          
        </div>

        <div className="relative mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-125" data-mp="3j893p1w0vrk9">
          <div className="absolute inset-x-2 bottom-6 top-10 rounded-3xl bg-navy" aria-hidden="true" data-id="element-126" data-mp="3o7vj9hzbpjw8" />
          <img src={optimizedImage(heroImage, 960)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS)} sizes={HERO_SIZES} alt="HANDBALL 360 READY™ complete: 6 visual coaching volumes, a session-plan tablet view, and 5 practical coaching bonuses." className="relative mx-auto w-full max-w-md sm:max-w-xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} style={{
          width: "299px",
          height: "297px"
        }} data-id="element-127" data-mp="39b4h50y9lu2x" />
        </div>

        <div className="mt-6 text-center lg:col-start-1 lg:row-start-2 lg:mt-6 lg:self-start lg:text-left" data-id="element-128" data-mp="2vi55ja1lsk0n">
          <p className="mx-auto max-w-xl text-[0.95rem] leading-relaxed text-muted lg:mx-0" style={{
          fontSize: "12px"
        }} data-id="element-129" data-mp="2hk86m6zog1it">
            The complete digital PDF system for handball coaches: step-by-step
            technique, illustrated drills, progressions, court diagrams, common
            errors, quick fixes, decision-making exercises, and complete
            sessions already organized for you.
          </p>

          <div className="mt-7" data-id="element-130" data-mp="ia5i8v83qdt4">
            <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-131" data-mp="ddf4iejrruav">
              Get full access now
            </CtaButton>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-132" data-mp="1b04d578z955p">
            {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 text-sm text-muted" data-id="element-133" data-mp="15zzupboie0cu">
                <CheckIcon className="h-4 w-4 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-134" data-mp="114swukhx7pvu" />
                {badge}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-y border-line bg-navy" data-id="element-135" data-mp="3luiaiu6w15my">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-2 sm:px-6" data-id="element-136" data-mp="3hrlp6vpyqvfb">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-7 text-center" data-id="element-137" data-mp="1xa429a5swchi">
              <dt className="mt-2 font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted sm:text-sm" data-id="element-138" data-mp="21aejxk2ygrc7">
                {stat.label}
              </dt>
              <dd className="font-display text-5xl font-extrabold leading-none text-accent sm:text-6xl" data-id="element-139" data-mp="2686946c7tzcp">
                {stat.value}
              </dd>
            </div>)}
        </dl>
        <p className="border-t border-line py-3 text-center font-display text-sm font-bold uppercase tracking-[0.4em] text-fg" data-id="element-140" data-mp="2fziymrajkdfk">
          Courtside ready
        </p>
      </div>
    </header>;
}